<template>
  <PageTable :orderTechDocCode="orderTechDocCode" />
</template>
<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    orderTechDocCode: { type: String, default: '' },
  },
}
</script>
